/**
 * @generated SignedSource<<e529af63327db0d7bce8ab7eadbc2023>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type InvoiceType = "REGULAR" | "REVERSE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type InvoiceHeader_invoice$data = {
  readonly customerAccount: {
    readonly customerName: string;
  };
  readonly id: string;
  readonly invoiceNumber: string | null | undefined;
  readonly relatedInvoiceIdentifier: string | null | undefined;
  readonly type: InvoiceType;
  readonly " $fragmentType": "InvoiceHeader_invoice";
};
export type InvoiceHeader_invoice$key = {
  readonly " $data"?: InvoiceHeader_invoice$data;
  readonly " $fragmentSpreads": FragmentRefs<"InvoiceHeader_invoice">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InvoiceHeader_invoice",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "invoiceNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CustomerAccount",
      "kind": "LinkedField",
      "name": "customerAccount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customerName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "relatedInvoiceIdentifier",
      "storageKey": null
    }
  ],
  "type": "Invoice",
  "abstractKey": null
};

(node as any).hash = "42d04d6eaf87f168455b3ab2e3470fab";

export default node;
